<template>
    <div class="form">
        <a-card size="small" :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
        </a-card>

        <channelSelecter :isDisabled="true" style="border-bottom:1px solid #eaeaea;" @onChannelCodeChange="handleCodeChange"></channelSelecter>

        <div class="bolck_box">
            <a-card  size="small" title="设置模板信息">
                <a-row>
                    <a-col :span="4">

                    </a-col>
                    <a-col :span="16">
                        <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout">
                            <a-form-model-item ref="templatename" label="模板名称" prop="templatename">
                                <a-input v-if="is_vue_task" v-model="record.templatename" @blur=" () => {$refs.templatename.onFieldBlur();}" />
                                <span v-else>{{record.templatename}}</span>
                            </a-form-model-item>

                            <a-form-model-item label="选择通道">
                                <a-select v-if="is_vue_task" v-model="record.passwaytype" style="width: 150px" show-search
                                    placeholder="选择通道类型">
                                    <a-select-option v-for="item in passwaytypes" :key="item.passwaytype">
                                        {{ item.passwaytypename }}
                                    </a-select-option>
                                </a-select>
                                <span v-else>{{record.passwaytypename}}</span>
                            </a-form-model-item>

                        </a-form-model>
                    </a-col>
                </a-row>

            </a-card>
        </div>

        <div class="bolck_box">
            <a-card  size="small">
                <a-tabs default-active-key="01" >
                    <a-tab-pane key="01" tab="站内信">
                        <noticeEditor ref="noticeEditorID" :is_vue_task="is_vue_task"></noticeEditor>
                    </a-tab-pane>
                    
                </a-tabs>
            </a-card>
        </div>


        <a-button type="primary" @click="handleOk" :loading="confirmLoading" style="display:block;margin:24px auto;">
            保存
        </a-button>
    </div>

</template>
<script>
import noticeEditor from './editors/noticeEditor'
import channelSelecter from '../components/channelSelecter'
const m_title = {
    'add_templete':'新增模板',
    'detail_templete':'查看模板',
    'edit_templete':'编辑模板',
};

// const passwaytypes = {
//     '01':'站内信',
// }
export default {
    components:{
        noticeEditor,
        channelSelecter
    },
    data() {
        return {
            c_title:'',
            is_vue_task : true,
            is_new:false,
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            passwaytypes:[],
            rules: {
                templatename: [
                    { required: true, message: '请输入模板名称', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入1~50个字符', trigger: 'blur' },
                ],
                channelcode:[
                    { required: true, message: '请选择所属渠道', trigger: 'blur' },
                ],
            },
            confirmLoading: false,
            formItemLayout:'vertical',
            record:{
                id:'',
                channelcode:'',
                channelname:'',
                templatename:'',//--
                templatetitle:'',//--
                templatecontent:'',//--
                templateextras:'',//--
                passwaytype:'',//--
                passwaytypename:'',//--
                templatevariables:'',//--
                createtime:'',
                updatetime:'',
                updatetuser:'',
                createuser:''
            }
        };
    },

    methods: {
        handleCodeChange(item){
            this.record.channelcode = item.value;
            this.record.channelname = item.text;
            this.getChannelBinds();
        },
        
        getChannelBinds(){
            let that = this;
            let c_params = {
                urlparams: false,
                channelcode: this.record.channelcode,
            }
            that.$store.dispatch({
                type: "mcmsmanager/getpasswaybychannel",
                params: c_params,
                showMsg: false
            }).then((res) => {
                if (res.data.success == 1) {
                    that.passwayList = [];
                    let result = res.data.data;
                    if (!result) {
                        that.message.error("未查询到渠道");
                        return;
                    }
                    this.passwaytypes = result;
                    if(result.length > 0 && this.record.id == ''){
                        this.record.passwaytype = result[0].passwaytype
                    }
                    
                }
            }).catch(() => {

            });
        },
        handleOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    let subResult = this.$refs.noticeEditorID.getExtraStr();
                    if(subResult){
                        this.record.templatetitle = subResult.templatetitle;
                        this.record.templatecontent = subResult.templatecontent;
                        this.record.templateextras = subResult.templateextras;
                        this.record.templatevariables = subResult.templatevariables;
                        //
                        let cPasswayType = this.record.passwaytype;
                        this.record.passwaytypename = this.passwaytypes.filter((n) => { return n.passwaytype == cPasswayType })[0];

                        this.submitData();
                    }
                    else{
                        return false;
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },

        submitData(){
            this.confirmLoading = true;
            const { params } = this.$route;
            if(params.action == 'edit_templete'){
                this.record.updatetime = new Date().Format('yyyy/MM/dd hh:mm:ss');
                this.record.updatetuser = this.G.getCurrentUser().username;
                this.$store
                    .dispatch({
                        type: "mcmsmanager/updatetemplete",
                        params: this.record
                    })
                    .then((response) => {
                        if(response.data.success == '1'){
                            this.handleCancel();
                        }
                        this.confirmLoading = false;
                    });
            }
            else if(params.action == 'add_templete'){
                this.record.id = '';
                this.record.createtime = new Date().Format('yyyy/MM/dd hh:mm:ss');
                this.record.createuser = this.G.getCurrentUser().username;
                //新增
                this.$store
                    .dispatch({
                        type: "mcmsmanager/addtemplete",
                        params: this.record
                    })
                    .then((response) => {
                        if(response.data.success == '1'){
                            this.handleCancel();
                        }
                        this.confirmLoading = false;
                    });
            }
        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
            this.loadEditor();
        },

        getDetail(id){
            let that = this;
            that.$store.dispatch({
                type: "mcmsmanager/querytempleteone",
                params: {
                    id:id,
                },
                showMsg: false
            }).then((res) => {
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.record = {
                        ...result
                    }
                    that.loadEditor();
                    
                }
            });
        },

        loadEditor(){
            this.$refs.noticeEditorID.loadData(this.record,this.is_vue_task);
        }
    },

    mounted(){
        const { query, params } = this.$route;
        this.c_title = m_title[params.action];
        this.is_new = params.action == "add_templete";
        if (!this.is_new) {
            this.getDetail(query.id)
        }
        else{
            this.resetForm();
        }
        this.is_vue_task = params.action != 'detail_templete'

    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}


.bolck_box{
    padding: 20px;
}


</style>
